import React from 'react';

const FormFieldInputText = ({
  type,
  className,
  isRenderedField,
  onChange,
  ...rest
}) => {
  const dynamicProps = {};

  if (isRenderedField) {
    dynamicProps.onChange = onChange;
  } else {
    dynamicProps.readOnly = true;
    dynamicProps.disabled = true;
  }

  return (
    <input type={type} className={className} {...dynamicProps} {...rest} />
  );
};

FormFieldInputText.defaultProps = {
  className: 'span30',
  isRenderedField: false,
  onChange: () => { }
};

export default FormFieldInputText;
